/**
 * Created by razial on 18.09.2026.
 */

cleverapps.overrideStyles(cleverapps.styles.LevelPassWindow, {
    window: {
        padding: {
            left: 25,
            right: 25
        }
    },

    "progress": {
        x: { align: "right", dx: -6 }
    }
});
